import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue'),

    },
    {
        path: '/product',
        name: 'product',
        component: () => import(/* webpackChunkName: "about" */ '../views/ProductView.vue'),

    },
    {
        path: '/shoppingCart',
        name: 'shoppingCart',
        component: () => import(/* webpackChunkName: "about" */ '../views/ShoppingCart.vue'),

    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
